module.exports = __webpack_public_path__ + "img/arrow-left.4c837338.svg";